module.exports = __webpack_public_path__ + "img/monitcelli.36376b87.jpeg";